import React from 'react'
import { useParams } from 'react-router-dom'
import { useIntl } from 'react-intl'
import { useRecoilState, useRecoilValue } from 'recoil'
import {
  FormElement,
  InputText,
  makeInputWithEmojiPicker
} from 'mailup-web-components'
import { messageState, subjectValidState } from '../../recoil/state/message'
import { MESSAGE_STR_TYPE_CONTENTSCAMPAIGN } from 'Constants'
import { pendoTrack } from 'Helpers/pendoTracking'
// Subject obbligatorio;
// OK -> se svuotato => bordo rosso;
// OK -> maxlength=200
// OK -> Load.SavedEmailWizard.LabelSubject

// OK -> Inserimento di emoticons solo se messageType!=3

// *****************  MESSAGE TYPE
// 0 export const MESSAGE_STR_TYPE_GENERIC = 'Generic'
// 1 export const MESSAGE_STR_TYPE_WELCOME = 'Welcome'
// 2 export const MESSAGE_STR_TYPE_CONFIRMATION = 'Confirmation'
// 3 export const MESSAGE_STR_TYPE_CONTENTSCAMPAIGN = 'ContentsCampaign'
// *****************  END

// ok -> Subject disabilitato se messageType==3
// ok -> Su selezione di emoji => invio evento di tracciamento su Pendo
// ok -> var pendoProps = {idMessage: {idNL},source: "emailMessageOverview"}
// ok -> pendoSettingsProvider.pendoTracking("Messages - Modal Emoji - Impression", pendoProps))
// ok -> Differenze rispetto alla versione attualeNuovo componente selezione emoticons
// ok -> https://dev-mailup-web-components.emailsp.info/?path=/story/react-components-emojipicker--input-with-emoji

// domande:
// 1: ASPETTO RETURN SEMPRE DEL COMPONENTE CHE SELEZIONA LE EMOJI ANCHE SE DISATTIVATO? CASO:  Subject disabilitato se messageType==3

const InputWithEmojiPicker = makeInputWithEmojiPicker(InputText)

const InputSubject = () => {
  const intl = useIntl()
  const { id } = useParams()

  const [
    { subject, isSubjectDirty, messageType },
    setSubjectState
  ] = useRecoilState(messageState)

  const valid = useRecoilValue(subjectValidState)

  const handleChange = ({ target: { value } }) => {
    setSubjectState(prev => ({
      ...prev,
      subject: value,
      isSubjectDirty: true,
      isDirty: true
    }))
  }

  // pendotracking
  const onSelectEmoticon = e => {
    pendoTrack('Messages - Modal Emoji - Impression', {
      idMessage: { id },
      source: 'emailMessageOverview'
    })
  }

  const retEmoji = (
    <FormElement
      required
      label={intl.formatMessage({ id: 'Load.SavedEmailWizard.LabelSubject' })}
      feedback={
        !valid
          ? intl.formatMessage({ id: 'Load.MailupCommon.Required' })
          : undefined
      }
    >
      <InputWithEmojiPicker
        value={subject}
        data-mu-test='input-subject-emoji'
        variant={!valid && isSubjectDirty ? 'danger' : undefined}
        maxLength='200'
        onChange={handleChange}
        onSelectEmoticon={onSelectEmoticon}
        strings={{
          search: intl.formatMessage({
            id: 'Load.EmojiComponent.SearchPlaceholder'
          }),
          clear: intl.formatMessage({ id: 'Load.EmojiComponent.Cancel' }), // Accessible label on "clear" button
          notfound: intl.formatMessage({ id: 'Load.EmojiComponent.NoResult' }),
          categories: {
            search: intl.formatMessage({
              id: 'Load.EmojiComponent.SearchResult'
            }),
            recent: intl.formatMessage({
              id: 'Load.EmojiComponent.CatFrequentlyUsed'
            }),
            smileys: intl.formatMessage({
              id: 'Load.EmojiComponent.CatSmileys'
            }),
            people: intl.formatMessage({ id: 'Load.EmojiComponent.CatPeople' }),
            nature: intl.formatMessage({
              id: 'Load.EmojiComponent.CatAnimals'
            }),
            foods: intl.formatMessage({ id: 'Load.EmojiComponent.CatFood' }),
            activity: intl.formatMessage({
              id: 'Load.EmojiComponent.CatActivity'
            }),
            places: intl.formatMessage({ id: 'Load.EmojiComponent.CatTravel' }),
            objects: intl.formatMessage({
              id: 'Load.EmojiComponent.CatObjects'
            }),
            symbols: intl.formatMessage({
              id: 'Load.EmojiComponent.CatSymbols'
            }),
            // flags: {intl.formatMessage({ id: 'Load.EmojiComponent.CatFlags' })},
            custom: intl.formatMessage({
              id: 'Load.EmojiComponent.CatFrequentlyUsed'
            })
          },
          categorieslabel: intl.formatMessage({
            id: 'Load.EmojiComponent.Categories'
          }) // Accessible title for the list of categories
        }}
      />
    </FormElement>
  )

  const retNoEmoji = (
    <FormElement
      labelFor='messageNote'
      label={intl.formatMessage({
        id: 'Load.SavedEmailWizard.LabelSubject'
      })}
    >
      <InputText
        disabled
        value={subject}
        onChange={handleChange}
        maxLength='100'
        data-mu-test='input-subject-no-emoji'
      />
    </FormElement>
  )

  return messageType === MESSAGE_STR_TYPE_CONTENTSCAMPAIGN
    ? retNoEmoji
    : retEmoji
}

export default InputSubject
